/**
 * FrequencyRole - Role para conversão de unidades de frequência
 *
 * Implementa os 4 pilares: Convert, Cast, Validate, Format
 *
 * @example
 * const freq = new FrequencyRole();
 * freq.convert('megahertz', 'hertz', 1)     // 1000000
 * freq.convert('rpm', 'hertz', 60)          // 1
 * freq.cast('hertz', '100 Hz')              // 100
 * freq.validate('hertz', 100)               // { valid: true, errors: [] }
 * freq.format('megahertz', 2.4)             // "2.4 MHz"
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { FREQUENCY_UNITS, FREQUENCY_ALIASES } from "./constants";

// =============================================================================
// FREQUENCY ROLE CLASS
// =============================================================================

export class FrequencyRole extends SimpleRole {
  readonly name = "frequency";
  readonly base = "hertz";
  readonly units = FREQUENCY_UNITS;
  readonly aliases = FREQUENCY_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Frequency cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da FrequencyRole */
export const frequencyRole = new FrequencyRole();
